import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import VueTimeago from "vue-timeago";
import axios from "axios";
import VueAxios from "vue-axios";

import VueChatScroll from "vue-chat-scroll";
import VueMobileDetection from "vue-mobile-detection";
Vue.use(VueMobileDetection);
Vue.use(VueChatScroll);
Vue.use(VueAxios, axios);
import firebase from "firebase";
import firebaseConfig from "@/firebase/firebaseConfig";
var firebaseApp = firebase.initializeApp(firebaseConfig);
// auth = firebaseApp.auth();

Vue.use(VueTimeago, {
  name: "Timeago", // Component name, `Timeago` by default
  locale: "es", // Default locale
  // We use `date-fns` under the hood
  // So you can use all locales from it
  locales: {
    es: require("date-fns/locale/es")
  }
});
Vue.config.productionTip = false;
Vue.prototype.$QB = window.QB;
Vue.prototype.$firebaseApp = firebaseApp;
let vue = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

vue.$store.commit("initialiseStore");
